// extracted by mini-css-extract-plugin
export default {"oosPopoverWrapper":"Ip-z","slideIn":"Jp-z"};